type IconSrcOptions = {
  iconSrc?: string;
  fallback: string;
};

export const resolveIconSrc = (key: string, { iconSrc, fallback }: IconSrcOptions): string => {
  if (iconSrc) return iconSrc;
  if (key.startsWith("/")) return key;
  return fallback;
};
